import { useEffect, useState } from 'react';
import useConfigStore from '@/stores/useConfigStore';
import {
  StorageKeys,
  StorageService,
} from '@/services/storage/Storage.service';
import { EnvironmentName } from '@/shared/config';
import SentryService from '@/services/sentry/Sentry.service';
import { IS_WEB } from '@/shared/constants/utility';

export function useLoadEnvironment(): boolean {
  const environment = useConfigStore((state) => state.environment);
  const setEnvironment = useConfigStore((state) => state.setEnvironment);
  const setLocalIP = useConfigStore((state) => state.setLocalIP);
  const [isEnvLoaded, setIsEnvLoaded] = useState(false);

  useEffect(() => {
    const loadLastEnvironment = async () => {
      const storedLocalIP = await StorageService.getItem(StorageKeys.LOCAL_IP);

      if (storedLocalIP) {
        await setLocalIP(storedLocalIP);
        __DEV__ && console.log(`Loaded stored localIP: ${storedLocalIP}`);
      } else {
        __DEV__ &&
          console.log(`No stored localIP found, using default: localhost`);
      }

      const storedEnvName = await StorageService.getItem(
        StorageKeys.ENVIRONMENT_NAME,
      );

      if (storedEnvName) {
        await setEnvironment(storedEnvName as EnvironmentName);
        __DEV__ && console.log(`Loaded stored environment: ${storedEnvName}`);
      } else {
        __DEV__ &&
          console.log(`No stored environment found, using default: production`);
      }
    };

    try {
      !IS_WEB && loadLastEnvironment();
      SentryService.init(environment);
    } catch (error) {
      SentryService.captureError('Error loading environment', error);
    } finally {
      setIsEnvLoaded(true);
    }
    // Only run this effect on initial app load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isEnvLoaded;
}
